<template>
	<div>
		<table class="table">
			<tbody>
				<tr>
					<td>Client</td>
					<td>{{ booking.client.name }}</td>
				</tr>
				<tr>
					<td><strong>Location</strong></td>
					<td>{{ booking.address }}, {{ booking.suburb.name }}</td>
				</tr>
				<tr>
					<td><strong>Type</strong></td>
					<td>
						{{ booking.service }}
						<template v-if="booking.service === 'Regular'">
							{{ booking.frequency }}
						</template>
					</td>
				</tr>
				<tr v-if="booking.service == 'Oneoff'">
					<td><strong>Oneoff Type</strong></td>
					<td>{{ booking.oneoff_type }}</td>
				</tr>
				<tr>
					<td><strong>Hours</strong></td>
					<td>{{ booking.hours }} Hours</td>
				</tr>
				<tr>
					<td><strong>Days</strong></td>
					<td>{{ booking.days }}</td>
				</tr>
				<tr>
					<td><strong>Start Date</strong></td>
					<td>{{ moment(booking.start_date).format('DD/MM/YYYY') }}</td>
				</tr>
				<tr v-if="booking.end_date">
					<td><strong>End Date</strong></td>
					<td>{{ moment(booking.end_date).format('DD/MM/YYYY') }}</td>
				</tr>
				<tr v-if="booking.service !== 'Oneoff'">
					<td><strong>Products Required</strong></td>
					<td>{{ booking.requires_products ? 'Yes' : 'No' }}</td>
				</tr>
				<tr v-if="booking.service !== 'Oneoff'">
					<td><strong>Equipment Required</strong></td>
					<td>{{ booking.requires_equipment ? 'Yes' : 'No' }}</td>
				</tr>
				<tr>
					<td><strong>Rate</strong></td>
					<td>${{ booking.hourly_rate }}</td>
				</tr>
				<tr>
					<td><strong>Notes</strong></td>
					<td>
						{{ booking.job_offer_notes }}
						<template v-if="booking.extra_hour_free">
							<p class="text-danger">
								This is a new booking and the first service will have an extra hour free.
							</p>
						</template>
						<template v-if="booking.type === 'Commercial'">
							This is an insurance/NDIS service and you will be paid by the Agency
							weekly. You will receive instructions on how you will be paid.
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<p>Please select the best day to schedule the booking.</p>
		<table class="table table-bordered">
			<thead>
				<tr>
					<th
						v-for="day in booking.preferred_days"
						:key="day"
						class="text-center">
						{{ day.substr(0, 3) }}
					</th>
				</tr>
			</thead>
			<tbody>
				<template v-if="booking.preferred_days">
					<tr>
						<td
							v-for="day in booking.preferred_days"
							:key="day"
							class="text-center"
							width="20%">
							<BFormCheckbox :model-value="selected_days"
								:value="day"
								:disabled="!offer.available_days.includes(day)" @update:model-value="selected_days = $event"></BFormCheckbox>
							<small v-if="day === 'Saturday' && booking.type === 'Domestic' && booking.service !== 'Oneoff'">Extra $5 per hour</small>
							<span
								v-if="!offer.available_days.includes(day)"
								class="text-danger"
								style="font-size: 11px;">
								You don't have any availability on {{ day }}
							</span>
						</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		name: 'JobOfferBooking',
		props: {
			modelValue: {
				type: null,
				default: undefined,
			},
			value: {
				type: Object,
				default: undefined,
			},
			offer: {
				type: Object,
				required: true
			}
		},
		emits: ['update:modelValue'],
		computed: {
			booking() {
				return this.offer.booking
			},
			selected_days: {
				get() {
					return this.modelValue !== undefined ? this.modelValue : this.value;
				},
				set(value) {
					this.$emit('update:modelValue', value);
				}
			}
		},
	}
</script>

<style scoped>

</style>
